import * as React from "react";
import themeDark from "../shared/themeDark";
import { makeStyles, createStyles, MuiThemeProvider } from "@material-ui/core/styles";
import { AppBar, Toolbar, Theme, IconButton, Button, Typography, Snackbar } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Navbar from "../shared/Navbar";
import _, { isNull, isUndefined } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import addDays from "date-fns/addDays";
import { RootState } from "../../store/rootReducer";
import { useHistory } from "react-router";
import AssignVehicleModal from "./AssignVehicleModal";
import ScheduleTransferModal from "./ScheduleTransferModal";
import { showNavbar } from "../../store/modules/appStateSlice";
import { IAppPropsWithRoute } from "../../common/types";
import ISelectItem from "../popup/types/ISelectItem";
import HospitalPopup from "../popup/HospitalPopup";
import api from "../../store/api";
import { ISchedule } from "../../common/types";
import { filterLocationForPopup, getLocationsDataForPopup } from "../popup/hospitalPopupHelpers";
import YellowBox from "./helpers/YellowBox";
import { getData, getRoles, persistName, setData } from "./helpers/transferScheduleHelpers";
import TransferScheduleWidget from "./TransferScheduleWidget";
import PlannerWidget from "./planner/PlannerWidget";
import PlannerSelect from "../location/planner/PlannerSelect";
import { consts } from "../../common/consts";
interface TransferProps extends IAppPropsWithRoute {}

const useStylesSubHeader = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    menuButton: {
      marginLeft: 2,
    },
    centerText: {
      color: "#FFF",
      fontSize: 18,
      fontWeight: 700,
      opacity: 0.36,
      textTransform: "none",
    },
    centerButton: {
      minWidth: 0,
      padding: "5px 15px",
    },
  })
);

function SubHeader({ leftButtonClick, roles, selectedDay, onDayClick, title = "All Hospitals" }: any) {
  const classes = useStylesSubHeader();
  const history = useHistory();
  const active = { color: "#F4B827", opacity: 1 };
  return (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ backgroundColor: "#01224A", position: "fixed", top: "59px" }}>
        <Toolbar variant="dense" style={{ justifyContent: "space-between" }}>
          <span
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {!roles.hospitalSelectArrow  && (
              <Typography variant="h6" style={{ color: "#FFF", fontSize: 18, fontWeight: 400 }}>
                {title}
              </Typography>
            )}
            {roles.hospitalSelectArrow  && (
              <>
                <Typography variant="h6" style={{ color: "#FFF", fontSize: 18, fontWeight: 400, cursor: "pointer" }} onClick={leftButtonClick}>
                  {title}
                </Typography>
                <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={leftButtonClick}>
                  <KeyboardArrowDownIcon />
                </IconButton>
              </>
            )}          
          </span>
          {!(roles.isSMADriver || roles.isCustomerDriver) ? (
            <span
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Button className={classes.centerButton} onClick={() => onDayClick(format(addDays(new Date(), -1), "yyyy-MM-dd"))}>
                <Typography className={classes.centerText} style={format(addDays(new Date(), -1), "yyyy-MM-dd") == selectedDay ? active : {}}>
                  Past
                </Typography>
              </Button>
              <Button className={classes.centerButton} onClick={() => onDayClick(format(addDays(new Date(), 0), "yyyy-MM-dd"))}>
                <Typography className={classes.centerText} style={format(addDays(new Date(), 0), "yyyy-MM-dd") == selectedDay ? active : {}}>
                  Today
                </Typography>
              </Button>
              <Button className={classes.centerButton} onClick={() => onDayClick(format(addDays(new Date(), 1), "yyyy-MM-dd"))}>
                <Typography className={classes.centerText} style={format(addDays(new Date(), 1), "yyyy-MM-dd") == selectedDay ? active : {}}>
                  Tomorrow
                </Typography>
              </Button>
              {new Array(5)
                .fill(0)
                .map((item, index) => {
                  var nextDay = new Date();
                  nextDay.setDate(nextDay.getDate() + index + 2);
                  return nextDay;
                })
                .map((item, index) => (
                  <Button
                    key={format(addDays(new Date(), index + 2), "yyyy-MM-dd")}
                    className={classes.centerButton}
                    onClick={() => onDayClick(format(addDays(new Date(), index + 2), "yyyy-MM-dd"))}
                  >
                    <Typography
                      className={classes.centerText}
                      style={format(addDays(new Date(), index + 2), "yyyy-MM-dd") == selectedDay ? active : {}}
                    >
                      {item.toString().split(" ")[0]}
                    </Typography>
                  </Button>
                ))}
            </span>
          ) : null}
          {roles.canMakeBooking ? (
            <Button style={{ minWidth: 0, padding: 0 }} onClick={() => console.log("refreshScheduledList required")}>
              <YellowBox title="New Booking" onClick={() => history.push("/addbooking")} />
            </Button>
          ) : (
            <div />
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}

function TransferSchedule(props: TransferProps) {
  const popState = React.useState(false);
  const [selectedHospital, setSelectedHospital] = React.useState<any>("");
  const locationState = React.useState<ISelectItem[]>([]);
  const { authStore } = useSelector((state: RootState) => state);
  const { bookingToast } = useSelector((state: RootState) => state.appState);
  const dispatch = useDispatch();

  const [roles, setRoles] = React.useState<any>(getRoles(authStore));

  const [selectedLocations, setSelectedLocations] = React.useState<any>(getData("selectedLocations") || []);
  const [selectedDay, setSelectedDay] = React.useState(
    (getData("selectedDay") < format(addDays(new Date(), 0), "yyyy-MM-dd") || isUndefined(getData("selectedDay")) || isNull(getData("selectedDay")) ) ? format(new Date(), "yyyy-MM-dd") : (getData("selectedDay") || format(new Date(), "yyyy-MM-dd")));
  const [currentBookingId, setCurrentBookingId] = React.useState<string | null>(null);
  const [currentTransferId, setCurrentTransferId] = React.useState<string | null>(null);
  const [currentTripPlannerId, setCurrentTripPlannerId] = React.useState<string | null>(null);
  const [currentTransferData, setCurrentTransferData] = React.useState<ISchedule>();
  const [showVehicleModal, setShowVehicleModal] = React.useState(false);
  const [showScheduleModal, setShowScheduleModal] = React.useState(false);
  const [showScheduleModalAssignVehicleOption, setShowScheduleModalAssignVehicleOption] = React.useState(false);
  const [updatedTransfers, setUpdatedTransfers] = React.useState<any[]>([]);
  const [isLocationListLoaded, setIsLocationListLoaded] = React.useState(false);
  const updatedTrasfersRef = React.useRef(updatedTransfers);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setRoles(getRoles(authStore));
  }, [authStore]);

  const isPast = format(addDays(new Date(), -1), "yyyy-MM-dd") === selectedDay;
  const isPlannerMode = roles.canMakeEditBooking && roles.canScheduleTransfer && selectedLocations.length === 1 && !isPast;

  React.useEffect(() => {
    var checkroles =  authStore.data?.role.split(",").some( p => p === consts.Permissions.SMAViewSchedule||  p === consts.Permissions.ViewSchedule||  p === consts.Permissions.SMASuperUser)
    if(!checkroles && !roles.isAdmin)
    {
      props.history.push('/');
      return;
    }
    if (props.location.state) {
      //setBookingId(props.location.state);
      let now = new Date();
      var newTransfers = String(props.location.state)
        .split(",")
        .map((e) => ({
          TransferId: e,
          UpdatedDate: now,
        }));
      let newUpdatedTransfers = [...updatedTransfers, ...newTransfers];
      updatedTrasfersRef.current = newUpdatedTransfers;
      setUpdatedTransfers(newUpdatedTransfers);
      //handleClickOpen();
      props.history.replace({
        pathname: "/transferschedule",
        state: undefined,
      });
    }
  }, []);

  const getLocationsData = async (): Promise<void> => {
    await getLocationsDataForPopup(locationState, setSelectedHospital, setSelectedLocations, selectedLocations, persistName);
  };

  React.useEffect(() => {
    getLocationsData().then(() => {
      setIsLocationListLoaded(true);
    });
    dispatch(showNavbar(false));
  }, []);

  const filterLocation = () => {
    filterLocationForPopup(locationState, setSelectedHospital, setSelectedLocations, persistName);
  };

  // filter locations that is not PatientTransport, filter empty clusters (isGroup) afterwards
  const patientTransportLocations = locationState[0].filter((l) => l.isPatientTransport || l.isGroup);
  const patientTransportLocationsWithoutEmptyGroups = patientTransportLocations.filter((l, ind) => {
    if (ind + 1 == patientTransportLocations.length) {
      if (l.isGroup) {
        return false;
      } else {
        return true;
      }
    }
    if (l.isGroup && patientTransportLocations[ind + 1].isGroup) {
      return false;
    }
    return true;
  });

  if (!isLocationListLoaded) {
    return null;
  }

  return (
    <>
      <MuiThemeProvider theme={themeDark}>
        <div style={{ position: "sticky", top: 0, zIndex: 1297 }}>
          <Navbar />
          <div style={loading ? {pointerEvents: "none"} : {}}>
            <SubHeader
              roles={roles}
              selectedDay={selectedDay}
              onDayClick={(date: string) => {
                setSelectedDay(date);
                setData("selectedDay", date);
              }}
              title={selectedHospital}
              leftButtonClick={() => popState[1](true)}
            />
          </div>
        </div>
        {isPlannerMode ? (
          <PlannerWidget
            selectedDay={selectedDay}
            selectedLocations={selectedLocations}
            setCurrentBookingId={setCurrentBookingId}
            setCurrentTransferId={setCurrentTransferId}
            setCurrentTransferData={setCurrentTransferData}
            setShowVehicleModal={setShowVehicleModal}
            setShowScheduleModal={setShowScheduleModal}
            setCurrentTripPlannerId={setCurrentTripPlannerId}
            setShowScheduleModalAssignVehicleOption={setShowScheduleModalAssignVehicleOption}
            roles={roles}
            setParentLoading={setLoading}
          />
        ) : (
          <TransferScheduleWidget
            selectedDay={selectedDay}
            selectedLocations={selectedLocations}
            setCurrentBookingId={setCurrentBookingId}
            setCurrentTransferId={setCurrentTransferId}
            setCurrentTransferData={setCurrentTransferData}
            setShowVehicleModal={setShowVehicleModal}
            setShowScheduleModal={setShowScheduleModal}
            setCurrentTripPlannerId={setCurrentTripPlannerId}
            setShowScheduleModalAssignVehicleOption={setShowScheduleModalAssignVehicleOption}
            roles={roles}
            setParentLoading={setLoading}
          />
        )}
        <HospitalPopup
          popState={popState}
          filterLocation={filterLocation}
          locationState={[patientTransportLocationsWithoutEmptyGroups, locationState[1]]}
        />
        <ScheduleTransferModal
          open={showScheduleModal}
          onClose={() => {
            setShowScheduleModal(false);
            setShowScheduleModalAssignVehicleOption(false);
          }}
          currentPriority={1}
          transferId={currentTransferId || ""}
          bookingId={currentBookingId || ""}
          fromTransfer={true}
          currentTransferData={currentTransferData}
          showScheduleModalAssignVehicleOption={showScheduleModalAssignVehicleOption}
          roles={roles}
          locationId={isPlannerMode ? selectedLocations[0] : selectedLocations!==undefined ?selectedLocations[0]:null}
        />
        <AssignVehicleModal
          open={showVehicleModal}
          onClose={() => setShowVehicleModal(false)}
          transferId={currentTransferId || ""}
          bookingId={currentBookingId || ""}
          fromTransfer={true}
          currentTripPlannerId={currentTripPlannerId || ""}
          smaUser={authStore.data?.IsSMAUser}
          locationId={isPlannerMode ? selectedLocations[0] : null}
        />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={bookingToast ? bookingToast.open : false}
          message={bookingToast ? bookingToast.message : ""}
        />
      </MuiThemeProvider>
    </>
  );
}

export default React.memo(TransferSchedule);
